import { WebsiteRead } from '@/api/dashboard'
import { getWebsiteUrl } from '@/layouts/websites'
import { Theme } from '../types'

/**
 * Fetch default website theme from hub instance api.
 * @param website
 * @param type
 * @param fromPreviewInstance
 */
export const fetchWebsiteDefaultTheme = async (
  website: WebsiteRead,
  type: string,
  fromPreviewInstance?: boolean,
): Promise<Theme> => {
  const url = getWebsiteUrl({ website, mode: 'api', fromPreviewInstance })
  const response = await fetch(`${url}/api/theme-default?type=${type}`)
  return await response.json()
}
